var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "create-telnyx-channel" } },
    [
      _c("a-form", [
        _c("div", { staticClass: "form-section" }, [
          _c("h4", [_vm._v("Kanal Bilgileri")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "input-wrapper" },
            [
              _c("label", [_vm._v("Kanal Adı")]),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  attrs: {
                    "validate-status": _vm.getErrorStatus("name"),
                    help: _vm.getErrorMessage("name"),
                  },
                },
                [
                  _c("a-input", {
                    attrs: { placeholder: "Örn: Satış Hattı", name: "name" },
                    model: {
                      value: _vm.form.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "name", $$v)
                      },
                      expression: "form.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "input-wrapper" }, [
            _c("label", [_vm._v("Kullanıcı Seçimi")]),
            _vm._v(" "),
            !_vm.selectedUser
              ? _c(
                  "div",
                  { staticClass: "user-selection" },
                  [
                    _c(
                      "a-button",
                      {
                        attrs: { type: "dashed", icon: "user", block: "" },
                        on: {
                          click: function ($event) {
                            _vm.showUserPicker = true
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Kullanıcı Seç (Varsayılan: " +
                            _vm._s(_vm.user.name) +
                            ")\n                    "
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c("div", { staticClass: "selected-user" }, [
                  _c(
                    "div",
                    { staticClass: "user-info" },
                    [
                      _c(
                        "a-avatar",
                        {
                          staticStyle: { "margin-right": "12px" },
                          attrs: { size: 32 },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.getUserInitials(_vm.selectedUser)) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-details" }, [
                        _c("div", { staticClass: "user-name" }, [
                          _vm._v(_vm._s(_vm.selectedUser.name)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-email" }, [
                          _vm._v(_vm._s(_vm.selectedUser.email)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-left": "auto" },
                          attrs: { type: "link", icon: "close" },
                          on: {
                            click: function ($event) {
                              _vm.selectedUser = null
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            Kaldır\n                        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-section-row" }, [
          _c("div", { staticClass: "form-section-half" }, [
            _c("h4", [_vm._v("Telnyx Hesap Bilgileri")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v("Username *")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("username"),
                      help: _vm.getErrorMessage("username"),
                    },
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        placeholder: "Telnyx kullanıcı adınız",
                        name: "telnyx-username",
                        autocomplete: "off",
                      },
                      model: {
                        value: _vm.form.username,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "username", $$v)
                        },
                        expression: "form.username",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v("Password *")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("password"),
                      help: _vm.getErrorMessage("password"),
                    },
                  },
                  [
                    _c("a-input-password", {
                      attrs: {
                        placeholder: "Telnyx şifreniz",
                        name: "telnyx-password",
                        autocomplete: "new-password",
                      },
                      model: {
                        value: _vm.form.password,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "password", $$v)
                        },
                        expression: "form.password",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v("API Key *")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("apiKey"),
                      help: _vm.getErrorMessage("apiKey"),
                    },
                  },
                  [
                    _c("a-input-password", {
                      attrs: {
                        placeholder: "Telnyx API anahtarınız",
                        name: "telnyx-apikey",
                        autocomplete: "off",
                      },
                      model: {
                        value: _vm.form.apiKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "apiKey", $$v)
                        },
                        expression: "form.apiKey",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v("Caller Phone Number *")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status":
                        _vm.getErrorStatus("callerPhoneNumber"),
                      help: _vm.getErrorMessage("callerPhoneNumber"),
                    },
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        placeholder: "Örn: +18445420900",
                        name: "callerPhoneNumber",
                        autocomplete: "off",
                      },
                      model: {
                        value: _vm.form.callerPhoneNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "callerPhoneNumber", $$v)
                        },
                        expression: "form.callerPhoneNumber",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-section-half" }, [
            _c("h4", [_vm._v("Bağlantı Ayarları")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v("Domain *")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("domain"),
                      help: _vm.getErrorMessage("domain"),
                    },
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        placeholder: "sip.telnyx.com",
                        name: "domain",
                        autocomplete: "off",
                      },
                      model: {
                        value: _vm.form.domain,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "domain", $$v)
                        },
                        expression: "form.domain",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input-wrapper" },
              [
                _c("label", [_vm._v("WebSocket Server *")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      "validate-status": _vm.getErrorStatus("websocketServer"),
                      help: _vm.getErrorMessage("websocketServer"),
                    },
                  },
                  [
                    _c("a-input", {
                      attrs: {
                        placeholder: "wss://sip.telnyx.com:7443",
                        name: "websocketServer",
                        autocomplete: "off",
                      },
                      model: {
                        value: _vm.form.websocketServer,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "websocketServer", $$v)
                        },
                        expression: "form.websocketServer",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-actions" },
          [
            _c(
              "a-button",
              {
                staticStyle: { "margin-right": "8px" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("cancel")
                  },
                },
              },
              [_vm._v(" İptal ")]
            ),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "primary", loading: _vm.creating },
                on: { click: _vm.handleSubmit },
              },
              [_vm._v(" Kanal Oluştur ")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: "Kullanıcı Seç",
            footer: null,
            width: "800px",
            bodyStyle: { padding: "15px" },
          },
          model: {
            value: _vm.showUserPicker,
            callback: function ($$v) {
              _vm.showUserPicker = $$v
            },
            expression: "showUserPicker",
          },
        },
        [_c("UserPicker", { on: { "user-selected": _vm.onUserSelected } })],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }